import { lazy } from 'react'

export default {
    path: '/report/analisi-commesse-aperte',
    title: 'Analisi commesse aperte',
    authenticated: true,
    component: lazy(() => import('./filter'))
}